/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { Input, Table, message } from "antd";
import { useDispatch, useSelector } from "react-redux";
import {
  getJackpotEntries,
  approveJackpotEntry,
  rejectJackpotEntry,
  addToFeedJackpotEntry,
  removeFromFeedJackpotEntry,
} from "../../features/jackpot/jackpotSlice";
import { Select } from "antd";
import { Modal } from "antd";
import { Link } from "react-router-dom";
import { IoSearchOutline } from "react-icons/io5";

const formatDate = (isoString) => {
  const date = new Date(isoString);

  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are zero-based
  const day = String(date.getDate()).padStart(2, "0");
  const hours = String(date.getHours()).padStart(2, "0");
  const minutes = String(date.getMinutes()).padStart(2, "0");

  return `${day}/${month}/${year} ${hours}:${minutes}`;
};

const JackpotEntries = () => {
  const dispatch = useDispatch();
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
    total: 1000,
    status: "",
    type: "",
    key: "",
  });
  const [searchQuery, setSearchQuery] = useState("");

  const handleInputChange = (event) => {
    setSearchQuery(event.target.value);
  };

  // Handle key down events on search
  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      setPagination({
        ...pagination,
        current: 1,
        key: searchQuery,
      });
    }
  };

  useEffect(() => {
    loadJackpotentries();
  }, [pagination]);

  async function loadJackpotentries() {
    dispatch(getJackpotEntries(pagination));
  }

  const { isLoading, jackpotEntries, jackpotEntryCount } = useSelector(
    (state) => state.jackpot
  );

  const handleTableChange = (pagination) => {
    dispatch(getJackpotEntries(pagination));
    setPagination({
      ...pagination,
      current: pagination.current,
      pageSize: pagination.pageSize,
    });
  };

  useEffect(() => {
    setPagination((prevPagination) => ({
      ...prevPagination,
      total: jackpotEntryCount,
    }));
  }, [jackpotEntryCount]);

  const handleApprove = (id) => {
    Modal.confirm({
      title: "Are you sure you want to approve this jackpot entry?",
      content: "This action cannot be undone.",
      onOk: async () => {
        // Dispatch the delete action if confirmed
        await dispatch(approveJackpotEntry({ id: id }));
        loadJackpotentries();
      },
      onCancel() {
        // Optional: handle cancellation
      },
    });
  };

  const handleReject = (id) => {
    Modal.confirm({
      title: "Are you sure you want to reject this entry?",
      content: "This action cannot be undone.",
      onOk: () => {
        // Dispatch the delete action if confirmed
        dispatch(rejectJackpotEntry({ id: id }));
      },
      onCancel() {
        // Optional: handle cancellation
      },
    });
  };

  const handleDownloadVideo = (record) => {
    Modal.confirm({
      title: "Are you sure you want to download this video?",
      onOk: () => {
        // Show downloading message
        message.loading({
          content: "Downloading...",
          key: "downloadMessage",
          duration: 0,
        });
        // Proceed with download
        handleDownload(record);
      },
      onCancel() {
        // Optional: handle cancellation
      },
    });
  };

  const handleDownload = async (record) => {
    try {
      const fileName = record.user ? record.user?.first_name + " " + record.user?.last_name : ""
      const timestamp = formatDate(record.createdAt);
      const response = await fetch(record.video_url);
      const blob = await response.blob();
      const blobUrl = window.URL.createObjectURL(blob);
  
      const link = document.createElement("a");
      link.href = blobUrl;
      link.setAttribute("download", fileName + "_" + timestamp + ".mp4");
      document.body.appendChild(link);
      link.click();
      link.remove();
  
      // Cleanup
      window.URL.revokeObjectURL(blobUrl);
      
      // Show success message and hide loading message
      message.success({
        content: "Download successful!",
        key: "downloadMessage",
        duration: 2,
      });
    } catch (error) {
      console.error("Download failed:", error);
      
      // Show error message and hide loading message
      message.error({
        content: "Download failed. Please try again.",
        key: "downloadMessage",
        duration: 2,
      });
    }
  };
  
    const handleAddToFeed = async (id) => {
      await dispatch(addToFeedJackpotEntry({ id: id }));
      loadJackpotentries();
      message.success({
        content: "Video has been successfully added to feed!",
        key: "downloadMessage",
        duration: 2,
      });
    };
  
    const handleRemoveFromFeed = async (id) => {
      await dispatch(removeFromFeedJackpotEntry({ id: id }));
      loadJackpotentries();
      message.success({
        content: "Video has been successfully removed from feed!",
        key: "downloadMessage",
        duration: 2,
      });
    };

  const columns = [
    {
      title: "User",
      dataIndex: "user",
      key: "user",
      render: (user) => (
        <span>{user ? user.first_name + " " + user.last_name : ""}</span>
      ),
    },
    {
      title: "Points",
      dataIndex: "points",
      key: "points",
    },
    {
      title: "Video",
      dataIndex: "video_url",
      key: "video_url",
      render: (video_url) => (
        <span>
          <video
            src={video_url}
            width="200"
            height="100"
            controls
            style={{ objectFit: "contain" }}
          />
        </span>
      ),
    },
    {
      title: "Entered At",
      dataIndex: "createdAt",
      key: "createdAt",
      render: (createdAt) => <span>{formatDate(createdAt)}</span>,
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: (status, record) => (
        <span>
          {status === 1 ? "Pending" : status === 2 ? "Approved" : "Rejected"}
        </span>
      ),
    },
    {
      title: "Action",
      dataIndex: "",
      key: "x",
      render: (status, record) => (
        <div style={{ display: 'flex', flexDirection: 'column' }}>
          <div>
            <Link
              to={`/admin/hole-in-one-video-submissions/${record.id}`}
              style={{ color: "blue", cursor: "pointer", textDecoration: "none" }}
            >
              Entry Details
            </Link>{" "}
            <span style={{ margin: "0 10px" }}>|</span>
            <a
              onClick={() => handleDownloadVideo(record)}
              style={{ color: "blue", cursor: "pointer" }}
            >
              Download
            </a>
          </div>
          {record.status === 1 && (
            <div style={{ marginTop: '8px' }}>
              <a
                onClick={() => handleApprove(record.id)}
                style={{ color: "green", cursor: "pointer" }}
              >
                Approve
              </a>
              <span style={{ margin: "0 10px" }}>|</span>
              <a
                onClick={() => handleReject(record.id)}
                style={{ color: "red", cursor: "pointer" }}
              >
                Reject
              </a>
            </div>
          )}
          {!record.is_added_to_feed ? (
            <div style={{ marginTop: "8px" }}>
              <a
                onClick={() => handleAddToFeed(record.id)}
                style={{ color: "blue", cursor: "pointer" }}
              >
                Add To Shot Feed
              </a>
            </div>
          ) : (
            <div style={{ marginTop: "8px" }}>
              <a
                onClick={() => handleRemoveFromFeed(record.id)}
                style={{ color: "blue", cursor: "pointer" }}
              >
                Remove From Shot Feed
              </a>
            </div>
          )}
        </div>
      ),
    },
  ];

  /** Handle dorp down for status is changed call search */
  const handleChange = (value) => {
    setPagination({
      ...pagination,
      current: 1,
      status: value,
    });
  };
  return (
    <div>
      <h3 className="mb-4 title">Video Submissions</h3>
      <div className="row-space-between">
        <div className="my-row">
          <div className="mr-5">
            <Input
              placeholder="Search users"
              value={searchQuery}
              onChange={handleInputChange}
              onKeyDown={handleKeyDown}
              prefix={<IoSearchOutline className="fs-4" />}
            />
          </div>
          <div style={{ marginLeft: "10px" }}>
            <Select
              defaultValue="All"
              style={{ width: 120 }}
              onChange={handleChange}
              options={[
                { value: "", label: "All" },
                { value: "1", label: "Pending" },
                { value: "2", label: "Approved" },
                { value: "3", label: "Rejected" },
              ]}
            />
          </div>
        </div>
      </div>
      <p> {isLoading} </p>
      <div>
        <Table
          columns={columns}
          dataSource={jackpotEntries}
          rowKey={(record) => record.id}
          onChange={handleTableChange}
          pagination={pagination}
          loading={isLoading}
          scroll={{ x: 1300 }}
          style={{ overflowX: "auto", whiteSpace: "nowrap" }}
        />
      </div>
    </div>
  );
};

export default JackpotEntries;
